import type { ReactNode } from 'react';
import { usePermissao } from '../hooks/use-permissao';
import { AcessoNegado } from './AcessoNegado';

/**
 * [F4.3 #890 / ADR-069 §13.27] Envolve o `element` de uma rota do `TenantLayout` — mostra
 * `AcessoNegado` quando o usuário acessa a URL direto sem ter a(s) permissão(ões) mapeada(s)
 * em `nav-config.ts` pro item de menu correspondente. Usuário sem NENHUMA atribuição RBAC
 * também cai aqui agora (`usePermissao().pode` fail-closed desde §13.27) — antes passava
 * sempre ("compatibilidade pré-backfill").
 *
 * Só aplicado nas rotas-folha que aparecem em `TENANT_NAV` — sub-rotas de detalhe
 * (`:id`) fora do menu não são cobertas aqui, mesmo padrão do gate por módulo existente
 * (`ModuloGuard` no backend protege TODAS as sub-rotas; o frontend só decide o que
 * aparece/quebra o menu, não varre cada `:id`).
 */
export function RequerPermissaoRota({
  codigo,
  children,
}: {
  codigo: string | string[];
  children: ReactNode;
}): JSX.Element {
  const { pode } = usePermissao();
  if (!pode(codigo)) return <AcessoNegado />;
  return <>{children}</>;
}
